import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { RouteComponentProps } from 'react-router';
import RoutePortal from "./RoutePortal";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";


class RoutePortalLoggedIn extends RoutePortal {

    componentDidMount() {
        this.componentWillUpdate();
    }

    componentWillUpdate(oldProps) {
        if (this.state.match) {
            if (!this.props.isLoggedIn) {
                let params = '';
                //debugger;
                //Handling query params after logged in.
                if (this.props.location && this.props.location.search) {
                    params = this.props.location.search;
                }
                this.props.setRedirectUrl(this.state.match.url, params);
            }
        }
    }

    render() {
        const { isProxyUser} = this.props;

        if (this.state.match) {
            if (this.props.isLoggedIn) {
                if (!this.props.hasMyChart || (isProxyUser && this.props.blockProxyUsers)) {
                    // in the event that we don't have MyChart where we should, just go back to the root of the site
                    //debugger;
                    return <Redirect push to="/" />;
                }
                else {
                    return super.render();
                }
            }
            else {
                //alert("redering a redirect here");
                //debugger;
                return <Redirect push to='/login' />;
            }
        }
        else {
            return "";
        }
    }

}


const mapStateToProps = (state, ownProps) => {
    return {
        isLoggedIn: state.domain.li, 
        hasMyChart: ownProps.RequireMyChart ? state.domain.hm : true, 
        isProxyUser: state.domain.ip
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRedirectUrl: (currentURL, params) => {
            //debugger;
            dispatch({ type: types.SET_REDIRECT_URL, URL: currentURL, params });
        },
        hideBannerOnCrash: (value) => { 
            dispatch({ type: types.HIDE_BANNER_ON_CRASH, value }); }
       };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutePortalLoggedIn);

